import { DS_SPACING_UNITS } from '@calm/evexia-design-tokens';
import { useIsMobile } from '@rhg/hooks/use-is-mobile';
import { Box, Typography, Stack } from '@rhg/libs/material';

const styleLeftAction = {
    position: 'absolute',
    left: 0,
};
const styleRightAction = {
    position: 'absolute',
    right: 40,
};
const styleHeaderContainer = {
    position: 'relative',
    width: '100%',
    my: { sm: DS_SPACING_UNITS.CONTENT, md: DS_SPACING_UNITS.SECTION },
};

interface ActionsHeaderProps {
    /** We can set a title or header, but not both */
    title?: string;
    /** We can set a title or header, but not both */
    header?: React.ReactNode;
    leftAction?: React.ReactNode;
    rightAction?: React.ReactNode;
}

export function ActionsHeader({
    header,
    title,
    leftAction,
    rightAction,
}: ActionsHeaderProps) {
    const isMobile = useIsMobile();
    if (!header && !title && !leftAction && !rightAction) {
        return null;
    }
    return (
        <Stack
            direction="row"
            justifyContent="center"
            alignItems="center"
            width="100%"
            my={DS_SPACING_UNITS.SECTION}
            sx={styleHeaderContainer}
        >
            <Box sx={styleLeftAction}>{leftAction}</Box>
            {header ? (
                <Box>{header}</Box>
            ) : title ? (
                <Typography
                    variant={isMobile ? 'h6' : 'h5'}
                    component="h1"
                    color="text.primary"
                    flexGrow={1}
                    textAlign="center"
                >
                    {title}
                </Typography>
            ) : null}
            <Box sx={styleRightAction}>{rightAction}</Box>
        </Stack>
    );
}
